"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M7 16c1.82 0 3.41-1.3 3.87-3H3.13c.46 1.7 2.05 3 3.87 3zm1-9c0 1.82 1.3 3.41 3 3.87V3.13C9.3 3.59 8 5.18 8 7zm9 1c-1.82 0-3.41 1.3-3.87 3h7.74c-.46-1.7-2.05-3-3.87-3zm-4 5.13v7.74c1.7-.46 3-2.04 3-3.87s-1.3-3.41-3-3.87z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23 12c0-3.25-2.75-6-6-6-1.52 0-2.93.6-4 1.57V1h-1C8.75 1 6 3.75 6 7c0 1.52.6 2.93 1.57 4H1v1c0 3.25 2.75 6 6 6 1.52 0 2.93-.6 4-1.57V23h1c3.25 0 6-2.75 6-6 0-1.52-.6-2.93-1.57-4H23v-1zM7 16c-1.82 0-3.41-1.3-3.87-3h7.74c-.46 1.7-2.05 3-3.87 3zm4-5.13C9.3 10.41 8 8.82 8 7s1.3-3.41 3-3.87v7.74zm2 10v-7.74c1.7.46 3 2.04 3 3.87s-1.3 3.41-3 3.87zm.13-9.87c.46-1.7 2.04-3 3.87-3s3.41 1.3 3.87 3h-7.74z"
})), 'ToysTwoTone');

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@material-ui+icons@4.11.3_@material-ui+core@4.12.4_@types+react@19.0.10_react-dom@16.14.0_rea_swut4f7lhb7ezcqzt2ohijeqoa/~/@material-ui/icons/ToysTwoTone.js
// module id = 5902
// module chunks = 0